import React from 'react';
import { Badge } from '../../components/ui/badge';

const DOT_CLASSES = {
  idle: 'bg-slate-300',
  running: 'bg-amber-400 animate-pulse',
  checking: 'bg-sky-400 animate-pulse',
  success: 'bg-emerald-500',
  failed: 'bg-red-500',
  warning: 'bg-yellow-500',
};

export const StatusDot = ({ status }) => (
  <div
    className={`w-2.5 h-2.5 rounded-full shrink-0 ${
      DOT_CLASSES[status] || DOT_CLASSES.idle
    }`}
  />
);

const BADGE_MAP = {
  idle: { label: 'Not Run', cls: 'border-slate-200 text-slate-500 bg-slate-50' },
  running: { label: 'Submitting...', cls: 'border-amber-200 text-amber-700 bg-amber-50' },
  checking: { label: 'Checking...', cls: 'border-sky-200 text-sky-700 bg-sky-50' },
  success: { label: 'Validated', cls: 'border-emerald-200 text-emerald-700 bg-emerald-50' },
  failed: { label: 'Failed', cls: 'border-red-200 text-red-700 bg-red-50' },
  warning: { label: 'Warning', cls: 'border-yellow-200 text-yellow-700 bg-yellow-50' },
};

export const StatusBadge = ({ status }) => {
  const { label, cls } = BADGE_MAP[status] || BADGE_MAP.idle;
  return (
    <Badge variant="outline" className={`text-[10px] ${cls}`}>
      {label}
    </Badge>
  );
};
